import { ENABLE_XP_PRE_CHECKOUT_RETAILER_EORI_COLLECTION_230912 } from "@faire/web-api/indigofair/settings/ENABLE_XP_PRE_CHECKOUT_RETAILER_EORI_COLLECTION_230912";

import { getSettingValueAndAssign } from "@faire/retailer/settings/__internal__/getSetting";

export const getSettingEnablePreCheckoutRetailerEoriCollection = (): boolean =>
  getSettingValueAndAssign(
    ENABLE_XP_PRE_CHECKOUT_RETAILER_EORI_COLLECTION_230912,
    false
  );
